import { useEffect } from 'react';

import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { doGetAccountApplication, getInvestigations } from 'src/actions';
import { useAccountApplicationSelector, useAccountSelector, useInvestigationListSelector } from 'src/hooks';
import { MSpinner } from 'src/lib';
import { AccountApplicationForm } from 'src/pages/AccountApplication';

import { MyAccountLayout } from '../../../lib/Layout/MyAccountLayout/MyAccountLayout';
import { MyAccountSidebarOtherMenuItemKey } from '../../../lib/Layout/MyAccountLayout/MyAccountSidebar';

import { AccountInvestigations } from './AccountInvestigations';
import * as Styles from './AccountStatus.styles';
import { AccountStatusHeader } from './AccountStatusHeader';

export const AccountStatus = () => {
  const { account } = useAccountSelector();
  const { isInvestigationListLoading } = useInvestigationListSelector();
  const { isAccountApplicationLoading } = useAccountApplicationSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    if (account?.accountId) {
      if (account?.type.isEntity && !account.isEntityAccountTypeActive && !isAccountApplicationLoading) {
        dispatch(doGetAccountApplication({ params: { id: account.applicationId, accountId: account.id } }));

        return;
      }

      if (!isInvestigationListLoading) {
        dispatch(getInvestigations(account.accountId));
      }
    }
  }, []);

  if (isInvestigationListLoading || isAccountApplicationLoading) {
    return <MSpinner />;
  }

  return (
    <MyAccountLayout sidebarMenuItemKey={MyAccountSidebarOtherMenuItemKey.AccountStatus} title='Account status'>
      <Row>
        <Col>
          <div className={Styles.formCard}>
            <AccountStatusHeader />
            {account?.type.isEntity && !account.isEntityAccountTypeActive ? (
              <AccountApplicationForm />
            ) : (
              <AccountInvestigations />
            )}
          </div>
        </Col>
      </Row>
    </MyAccountLayout>
  );
};
